import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { pick, noop } from 'lodash';

import { bemHelper } from '@dbk/ui-react-utils';

import DropdownButton from './dropdown-button';
import DropdownContainer from './dropdown-container';

import { DropdownPropTypes, DropdownDefaultProps } from './dropdown-common';

import styles from './dropdown.css';

const bem = bemHelper(styles, 'dropdown');

const DropdownField = (props) => {
  const {
    id,
    dropdownClasses,
    tabIndex,
    childRef,
    childId,
    open,
    testID,
    eventHandlers,
    selectedTextValue,
    selected,
    renderSelectedOption,
    renderMobileOptions,
  } = props;

  const dropdownWrapperClass = classnames(dropdownClasses, {
    [bem(null, 'open')]: open,
  });

  return (
    <DropdownContainer
      id={id}
      dropdownWrapperClass={dropdownWrapperClass}
      tabIndex={tabIndex}
      dropdownRef={childRef}
      childId={childId}
      isOpen={open}
      testID={testID}
      eventHandlers={eventHandlers}
    >
      <DropdownButton
        id={childId}
        value={selectedTextValue}
        selected={selected}
        renderSelectedOption={renderSelectedOption}
      />
      {renderMobileOptions()}
    </DropdownContainer>
  );
};

DropdownField.propTypes = {
  ...pick(DropdownPropTypes, ['testID', 'selected', 'renderSelectedOption']),
  id: PropTypes.string,
  className: PropTypes.string,
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  childRef: PropTypes.func,
  childId: PropTypes.string,
  open: PropTypes.bool,
  eventHandlers: PropTypes.object,
  selectedTextValue: PropTypes.string,
  renderMobileOptions: PropTypes.func,
};

DropdownField.defaultProps = {
  ...pick(DropdownDefaultProps, ['testID', 'selected', 'renderSelectedOption']),
  id: undefined,
  className: undefined,
  tabIndex: 0,
  childRef: noop,
  childId: undefined,
  open: false,
  eventHandlers: undefined,
  selectedTextValue: '',
  renderMobileOptions: noop,
};

export default DropdownField;
